/**
 * Cornerstone.js initialization for DICOM viewing
 * This must be called before using any DICOM viewer components
 */

import * as cornerstone from 'cornerstone-core';
import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import dicomParser from 'dicom-parser';

// Flag to track initialization
let isInitialized = false;

/**
 * Initialize cornerstone and its image loaders
 */
export function initCornerstone() {
  if (isInitialized) {
    console.log('Cornerstone already initialized');
    return;
  }

  try {
    // Configure the WADO image loader with external dependencies
    cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
    cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
    
    // Configure web workers for decoding (optional but improves performance)
    try {
      const config = {
        maxWebWorkers: navigator.hardwareConcurrency || 4,
        startWebWorkersOnDemand: true,
        taskConfiguration: {
          decodeTask: {
            initializeCodecsOnStartup: true,
            usePDFJS: false,
            strict: false,
          },
        },
      };

      cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
    } catch (workerError) {
      console.warn('Web workers initialization failed, will use main thread:', workerError);
    }

    // Register the wadouri image loader
    cornerstone.registerImageLoader('wadouri', cornerstoneWADOImageLoader.wadouri.loadImage);
    
    // Also register for wadors (DICOM Web)
    if (cornerstoneWADOImageLoader.wadors) {
      cornerstone.registerImageLoader('wadors', cornerstoneWADOImageLoader.wadors.loadImage);
    }

    isInitialized = true;
    console.log('Cornerstone initialized successfully');
  } catch (error) {
    console.error('Error initializing cornerstone:', error);
    // Don't throw - allow the app to continue even if DICOM init fails
  }
}

/**
 * Check if cornerstone is initialized
 */
export function isCornerstoneInitialized() {
  return isInitialized;
}

// Auto-initialize on import
initCornerstone();

export default initCornerstone;
